export default __webpack_public_path__ + "static/media/TotalOrders.bd0d7a29.svg";